<template>
    <div>
        <div class="container-fluid" style="background-color: white">
            <br>
            <h4>รายงาน - ยอดขายตามพื้นที่ลูกค้า</h4>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline">
                        <date-picker v-model="search.date"
                                     :lang="lang"
                                     range
                                     :format="changeFormat"
                                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด" confirm>
                        </date-picker> &nbsp;
                        <multiselect
                            class="form-control border-0"
                            :options="sellers"
                            v-model="search.sale"
                            label="name"
                            :show-labels="false"
                            placeholder="ค้นหาเซลล์"
                            track-by="id">
                        </multiselect> &nbsp;
                        <multiselect
                            class="form-control border-0"
                            :options="provinces"
                            v-model="search.province"
                            @input="getDistricts(search.province)"
                            label="name"
                            :show-labels="false"
                            placeholder="ค้นหาจังหวัด"
                            track-by="id">
                        </multiselect> &nbsp;
                        <multiselect v-if="search.province"
                                     class="form-control border-0"
                                     :options="districts"
                                     v-model="search.district"
                                     @input="getSubDistricts(search.district)"
                                     label="name"
                                     :show-labels="false"
                                     placeholder="ค้นหาเขต / อำเภอ"
                                     track-by="id">
                        </multiselect> &nbsp;
                        <multiselect v-if="search.district"
                                     class="form-control border-0"
                                     :options="subDistricts"
                                     v-model="search.sub_district"
                                     label="name"
                                     :show-labels="false"
                                     placeholder="ค้นหาแขวง / ตำบล"
                                     track-by="id">
                        </multiselect> &nbsp;
                        <button type="button" class="btn btn-success" @click="searchReportCustomer">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                    </form>
                </div>
            </nav>
            <div class="col-sm-12 table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th rowspan="2">ลูกค้า</th>
                        <th rowspan="2">เซลล์</th>
                        <th rowspan="2">ตำบล</th>
                        <th rowspan="2">อำเภอ</th>
                        <th rowspan="2">จังหวัด</th>
                        <th colspan="6">ยอดขาย</th>
                        <th colspan="6">จำนวนขาย</th>
                    </tr>
                    <tr>
                        <template v-for="thead in type">
                            <th>{{ thead.text }}</th>
                        </template>
                        <template v-for="thead in type">
                            <th>{{ thead.text }}</th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="customers in customer_group_product">
                        <tr>
                            <td> <!---ลูกค้า-->
                                <template v-if="customers.customer">
                                    {{ customers.customer['customer_id'] }}
                                    {{ customers.customer['store_name'] ? customers.customer['store_name'] : customers.customer['first_name'] }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td><!---เซลล์-->
                                <template v-if="customers.sale">
                                    {{ customers.sale.name }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td><!---ตำบล-->
                                <template v-if="customers.customer && customers.customer.sub_district">
                                    {{ customers.customer.sub_district.name }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td><!---อำเภอ-->
                                <template v-if="customers.customer && customers.customer.district">
                                    {{ customers.customer.district.name }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td><!---จังหวัด-->
                                <template v-if="customers.customer && customers.customer.province">
                                    {{ customers.customer.province.name }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <!--quantity-->
                            <td>
                                <template v-if="customers.form">
                                    {{ customers.form.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.glass">
                                    {{ customers.glass.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.spoon">
                                    {{ customers.spoon.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.tube">
                                    {{ customers.tube.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.other">
                                    {{ customers.other.quantity | amount }}
                                </template>
                            </td>
                            <td style="font-weight: bold">
                                {{ customers.total_quantity | amount }}
                            </td>
                            <!--price-->
                            <td>
                                <template v-if="customers.form">
                                    {{ customers.form.total_price | currency }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.glass">
                                    {{ customers.glass.total_price | currency }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.spoon">
                                    {{ customers.spoon.total_price | currency }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.tube">
                                    {{ customers.tube.total_price | currency }}
                                </template>
                            </td>
                            <td>
                                <template v-if="customers.other">
                                    {{ customers.other.total_price | currency }}
                                </template>
                            </td>
                            <td style="font-weight: bold">
                                {{ customers.total_price | currency }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <br/>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
            </loading>
        </b-modal>
        <!--        <pre class="alert-success">{{customer_group_product}}</pre>-->
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import moment from "moment";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";

export default {
    name: "dashboard-customer",
    components: {
        Loading,
        VuePagination,
        DatePicker, Multiselect
    },
    created() {
        this.getReportCustomerList();
        this.$store.dispatch("Seller/get");
        this.$store.dispatch('Common/setProvince');
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            event_submit: false,
            customer_group_product: [],
            type: [
                {text: 'โฟม', value: 1},
                {text: 'แก้ว', value: 2},
                {text: 'ช้อน', value: 3},
                {text: 'หลอด', value: 4},
                {text: 'เบ็ดเตล็ด', value: 5},
                {text: 'รวม', value: 6},
            ],
            search: {
                sale: "",
                date: [],
                province: "",
                district: "",
                sub_district: ""
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            sellers: state => {
                return state.Seller.data;
            },
            provinces: state => {
                return state.Common.province;
            },
            districts: state => {
                return state.Common.districts;
            },
            subDistricts: state => {
                return state.Common.sub_districts;
            },
        })
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getDistricts(province) {
            this.search.district = "";
            this.search.sub_district = "";
            if (province) {
                //console.log(province.code);
                this.$store.dispatch('Common/setDistrict', province.code);
            }
        },
        getSubDistricts(districts) {
            this.search.sub_district = "";
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
            }
        },
        searchReportCustomer() {
            if (this.search.date.length < 1) {
                alert("กรุณาเลือกวันที่");
            } else if (!this.search.sale) {
                alert("กรุณาเลือกเซลล์");
            } else {
                let sale_id = "";
                let start_date = "";
                let end_date = "";
                let province_id = "";
                let district_id = "";
                let sub_district_id = "";
                if (this.search.sale) {
                    sale_id = this.search.sale.id;
                }
                if (this.search.date.length > 0) {
                    if (!this.search.date[0] && !this.search.date[1]) {
                        this.search.date = [];
                    }
                    if (this.search.date.length > 0) {
                        start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                        end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                    }
                }
                if (this.search.province) {
                    province_id = this.search.province.id
                }
                if (this.search.district) {
                    district_id = this.search.district.id
                }
                if (this.search.sub_district) {
                    sub_district_id = this.search.sub_district.id
                }
                let data = {
                    sale_id: sale_id,
                    start_date: start_date,
                    end_date: end_date,
                    province_id: province_id,
                    district_id: district_id,
                    sub_district_id: sub_district_id,
                };
                //console.log(data);
                this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("Dashboard/getReportCustomerByProduct", data).then(res => {
                    this.customer_group_product = res;
                    this.hideLoadingModal();
                }).catch(() => {
                    this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                });
            }
        },
        getPage() {
            if (this.event_submit) {
                this.searchReportCustomer();
            } else {
                this.getReportCustomerList();
            }
        },
        getReportCustomerList() {
            let data = {
                sale_id: 34,
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                province_id: "",
                district_id: "",
                sub_district_id: "",
            };
            this.$store.dispatch("Dashboard/getReportCustomerByProduct", data).then(res => {
                this.customer_group_product = res;
            });
        }
    }
}
</script>

<style scoped>

</style>
